import React, { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { ILink } from "../../../interfaces/Index";
import producticon from "../../../assets/images/down_arrow2.svg";

export const toggle = (setExpand: any, expand: boolean) => setExpand(!expand);

const Link: React.FunctionComponent<ILink> = (props: ILink) => {
  const [expand, setExpand] = useState(false);
  let parentNavActive: any = useRef(false);

  let mainNavClasses = props.isActive ? "nav active-nav" : "nav";

  mainNavClasses +=
    props.isEnable && props.childNav.length === 0 ? ` nav-disabled` : ``;

  const renderChildNav = () => {
    return props.childNav.map((item: any, i: number) => {
      let childNavClasses = item.isActive ? "nav active-nav" : "nav";
      childNavClasses += !item.isEnable ? " nav-disabled" : "";
      return (
        <li key={i} className={childNavClasses}>
          <a href={item.url}>
            <span>
              <img src={item.img} />
            </span>
            <span className="name">{item.name}</span>
          </a>
        </li>
      );
    });
  };

  const findActiveChild = () => {
    props.childNav.forEach((e) => {
      if (e.isActive) {
        parentNavActive.current = true;
      }
    });
  };

  findActiveChild();

  return (
    <li className={mainNavClasses}>
      <a
        href={props.childNav.length > 0 ? "javascript:void(0)" : props.url}
        className={props.childNav.length > 0 ? "sidebar-section" : ""}
        onClick={() => toggle(setExpand, expand)}
      >
        <span>
          <img src={props.img} />
        </span>
        <span className="name">{props.name}</span>
        {props.childNav.length > 0 && (
          <span className={expand && !parentNavActive.current ? "up" : "down"}>
            <img src={producticon} alt="Bazaar" />
          </span>
        )}
      </a>
      {props.childNav.length > 0 && (
        <ul
          className={`child-nav ${expand ? "expand" : "collapsed"} ${
            parentNavActive.current && "expand"
          }`}
        >
          {renderChildNav()}
        </ul>
      )}
    </li>
  );
};

export default Link;
